import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  InputLabel,
  Link,
  makeStyles,
  Slider,
  Typography,
} from "@material-ui/core";
import { Cancel, CloudUpload } from "@material-ui/icons";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ObjectToFormdata } from "../../../Common/Utils/common_utils";
import CustomInput from "../../../Components/CustomInput";
import CustomMultiSelectAutoComplete from "../../../Components/CustomMultiSelectAutoComplete";
import CustomRadioButton from "../../../Components/CustomRadioButton";
import CustomSelect from "../../../Components/CustomSelect";
import CustomSelectMulti from "../../../Components/CustomSelectMulti";
import DateComponent from "../../../Components/FormGenerator/datepicker_component";
import { GLOBAL_DATA, GLOBAL_STEPPER_DATA } from "../../../Redux/actions";
import AdminPartnerClient from "../../../Service/Admin/partner_services";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import AddToListModal from "../../../Components/FormGenerator/addToListModal";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
// import GroupDropdown from "../../../Components/FormGenerator/customSelectMulti";

import Header from "./header";
import SelectComponent from "../../../Components/FormGenerator/select_component";
import DataService from "../../../Service";
import { showSnackbar } from "../../../Components/Snackbar/SnackbarActions";
import StepperService from "./StepperService";
import { mappedKeyJSON } from "./MappedKeyJSON";
import CircularIndeterminate from "../../../Components/Loader";
import store from "../../../Redux/store";

const useStyles = makeStyles(() => ({
  labelText: {
    color: "#4D4F5C",
    fontSize: "16px",
    lineHeight: "22px",
  },
  autoComplete: {
    "& .MuiInputBase-input": {
      padding: "12px !important",
      fontSize: 16,
    },
    "& .MuiInputBase-input::placeholder": {
      color: "#808080",
      opacity: 1,
    },
    "& .MuiInput-underline:before, & .MuiInput-underline:after": {
      content: "' '",
      border: "0px !important",
      transition: "none",
    },
    "& .MuiAutocomplete-popupIndicator": {
      marginRight: 5,
    },
    "& .MuiAutocomplete-inputRoot": {
      border: "1px solid rgba(0, 0, 0, 0.23)",
      height: "44px",
      borderRadius: 5,
      "&.Mui-error": {
        borderColor: "#f44336",
      },
    },
  },
  autoCompleteInput: {
    "& .MuiOutlinedInput-input": {
      padding: "4px 14px !important",
    },
  },
}));

export const OnBoardingOptions = [
  { id: 1, label: "Onboarding", value: "Onboarding" },
  {
    id: 2,
    label: "Acuity Profile created (still to complete other stages",
    value: "Acuity Profile created (still to complete other stages",
  },
];
export const UtilisedOptions = [
  { id: 3, label: "Screened In", value: "Screened In" },
  { id: 4, label: "Shortlisted", value: "Shortlisted" },
  { id: 5, label: "Placed", value: "Placed" },
];
export const RankingOptions = [
  { id: 6, label: "Bottom Quartile", value: "Bottom Quartile" },
  { id: 7, label: "Lower Quartile", value: "Lower Quartile" },
  { id: 8, label: "Middle Quartile", value: "Middle Quartile" },
  { id: 9, label: "Top Quartile", value: "Top Quartile" },
];
export const DoNotContactOptions = [
  {
    id: 10,
    label: "No Contact Details",
    value: "No Contact Details",
  },
  {
    id: 11,
    label: "Application not progressed",
    value: "Application not progressed",
  },
  { id: 12, label: "Not screened in yet", value: "Not screened in yet" },
  { id: 13, label: "Screened out", value: "Screened out" },
  { id: 14, label: "Inactive", value: "Inactive" },
];
export const TagsOptions = [
  { id: 15, label: "Future project", value: "Future project" },
];

function BasicInfo(props: any) {
  const languageArr = ["English", "French", "German"];

  const data = {
    first_name: "",
    person_status_id: "",
    next_available_date: "",

    middle_name: "",
    last_name: "",
    full_name: "",
    email: "",
    company_name: "",
    phone: "",
    source: "",
    initial_contact_date: "",
    contact_location: "",
    referred_by: "",
    sourced_for: "",
    sourced1: "",
    source_referral3_id: "",
    associate_coach: "",
    associate_role: "",
    associate_bio: "",
    organisation_name: "",
    address: "",
    address_line1: "",
    address_line2: "",
    zipcode: "",
    city: "",
    county: "",
    country_list_id: "",
    general_internal_comment: "",
    access_level: "",
    facebook: "",
    linkedin: "",
    secondary_email: "",
    skype: "",
    twitter: "",
    service_authorisation: "",
    authorisation_provided_by: "",
    bame: "",
    diversity_inclusion: "",
    telephone: "",
    website: "",
    website2: "",
    visa_status: "",
    // nationality_list_id: "",
    document: "",
    title: "",
    gender: "",
    gender_text: "",
    country: "",
    open_questionnaire_section: "",
    acuity_profile_create: "",
    resume_boolean: "",
    currently_available_for_assignment: "",

    person_status: "",
    pa_name: "",
    pa_contact_details: "",
    office_address: "",
    business_address_line1: "",
    business_address_line2: "",
    business_city: "",
    business_country_list_id: "",
    business_postcode: "",
    business_zipcode: "",
    business_phone: "",
    business_mobile_number: "",
    location_radius: 0,
    business_county: "",
    fluency_id: "",
  };

  const ReviewArr = [
    {
      label: "Onboarding",
      options: OnBoardingOptions,
    },
    {
      label: "Utilised",
      options: UtilisedOptions,
    },
    {
      label: "Ranking",
      options: RankingOptions,
    },
    {
      label: "Do not contact",
      options: DoNotContactOptions,
    },
    {
      label: "Tags",
      options: TagsOptions,
    },
  ];

  const classes = useStyles();
  const dispatch = useDispatch();
  const candidateStatuseSelector = useSelector(
    (state: any) => state.commonReducer.employeeDropdowns.candidate_statuses
  );
  const global_data = useSelector((state: any) => state.stepperReducer);
  const global_data_common = useSelector((state: any) => state.commonReducer);
  const [submitClickFlag, setSubmitClickFlag] = React.useState(false);
  const [userData, setUserData] = useState<any>(data);
  const [partnerRolesArr, setPartnerRolesArr]: any = useState([]);
  const [languages_attribute, setLanguages_attribute]: any = useState([]);
  const [languageListsArr, setLanguageListsArr]: any = useState([]);
  const [source_1_referring, setSource_1_referring]: any = useState([]);
  const [source_3_referring, setSource_3_referring]: any = useState([]);
  const [
    source_2_referring_company_attribute,
    setSource_2_referring_company_attribute,
  ]: any = useState([]);
  const [source_3_referring_companyArr, setSource_3_referring_companyArr]: any =
    useState([]);
  const [
    source_3_referring_company_attribute,
    setSource_3_referring_company_attribute,
  ]: any = useState([]);
  const [suffix_attribute, setSuffix_attribute]: any = useState([]);
  const [suffixArr, setSuffixArr]: any = useState([]);
  const [dataArr, setDataArr]: any = useState([]);
  const [visaArr, setVisaArr]: any = useState([]);
  const [passportArr, setPassportArr]: any = useState([]);
  const [partnerDummyRoleArr, setPartnerDummyRoleArr]: any = useState([]);
  const [emailInvalidFlag, setEmailInvalidFlag]: any = useState(false);
  const [genderArr, setGenderArr]: any = useState([]);
  const [titleArr, setTitleArr]: any = useState([]);
  const [fluencyArr, setFluencyArr]: any = useState([]);
  const [sourceArr, setSourceArr]: any = useState([]);
  const [organisationPanelsAttribute, setOrganisationPanelsAtribute]: any =
    useState([]);
  const [organisationPanelsArr, setOrganisationPanelsArr]: any = useState([]);
  const [countryListsArr, setCountryListsArr]: any = useState([]);
  const [cityListsArr, setCityListsArr]: any = useState([]);
  const [levelListsArr, setLevelListsArr]: any = useState([]);
  const [showAddNewModal, setShowAddNewModal] = useState(false);
  const [showAddNewModalExist, setShowAddNewModalExist] = useState(false);
  const [addNewModalProps, setAddNewModalProps] = useState({});
  const [addNewFlag, setAddNewFlag] = useState(false);
  const [loading, setLoading] = useState(false);
  const [partnerListingData, setPartnerListingData] = useState([]);
  const [personStatusArr, setPersonStatusArr]: any = useState([]);
  const [candidateStatusArr, setCandidateStatusArr] = useState([]);
  const [candidateStatus_attribute, setCandidateStatus_attribute] = useState(
    []
  );
  const [nationalityArr, setNationalityArr] = useState([]);
  const [nationality_list_attribute, setNationality_list_attribute] = useState(
    []
  );
  const [businessCountryListsArr, setBusinessCountryListsArr]: any = useState(
    []
  );
  const [countyListsArr, setCountyListsArr]: any = useState([]);
  const [copyFlag, setCopyFlag]: any = useState(false);

  //  const globaluserData = useSelector((state) => state.commonReducer);
  //  const role = globaluserData?.role;
  // let role = sessionStorage.getItem("role");
  const [value, setValue] = React.useState("");
  const [inputValue, setInputValue] = React.useState("");
  const globaluserData = useSelector(
    (state: typeof store) => (state as any).commonReducer
  );
  let role = globaluserData?.role;

  const setInputState = (inputStateValue: any, inputId: any) => {
    if (inputId === "associate_coach") {
      inputStateValue = inputStateValue === "Yes" ? true : false;
    }
    if (inputId === "next_available_date") {
      dispatch({
        type: GLOBAL_STEPPER_DATA,
        payload: { next_available_date: inputStateValue },
      });
    }
    setUserData({ ...userData, [inputId]: inputStateValue });
  };
  const onChangeItem = (
    selectedItemValue: any,
    inputId: any,
    routeFrom: any
  ) => {
    if (routeFrom == "add_in_drop_down") {
      setUserData((prev: any) => ({ ...prev, [inputId]: selectedItemValue }));
      setAddNewFlag(true);
    } else {
      if (
        selectedItemValue.id === "sourced_for" ||
        selectedItemValue.id === "service_authorisation" ||
        selectedItemValue.id === "open_questionnaire_section" ||
        selectedItemValue.id === "acuity_profile_create" ||
        selectedItemValue.id === "currently_available_for_assignment" ||
        // selectedItemValue.id == "sourced1" ||
        selectedItemValue.id === "resume_boolean" ||
        selectedItemValue.id === "bame" ||
        selectedItemValue.id === "diversity_inclusion"
      ) {
        selectedItemValue.value =
          selectedItemValue.value === ""
            ? ""
            : selectedItemValue.value === "Yes"
            ? "true"
            : "false";
      }
      if (selectedItemValue.id === "country") {
        handleCityList(selectedItemValue.value);
      }
      if (selectedItemValue.id === "currently_available_for_assignment") {
        dispatch({
          type: GLOBAL_STEPPER_DATA,
          payload: {
            currently_available_for_assignment: selectedItemValue.value,
          },
        });
      }
      setUserData({
        ...userData,
        [selectedItemValue.id]: selectedItemValue.value,
      });
    }
  };
  const addNewHandler = (
    addNewModalExistFlag: any,
    modalFlag: any,
    addNewModalPropsData: any
  ) => {
    setShowAddNewModalExist(addNewModalExistFlag);
    setShowAddNewModal(modalFlag);
    setAddNewModalProps({ ...addNewModalProps, ...addNewModalPropsData });
  };
  const onChangeMultiItem = (
    obj: any,
    inputId: any,
    routeFrom: any,
    objId: any
  ) => {
    if (routeFrom === "add_in_drop_down") {
      if (inputId === "suffix_attributes") {
        setSuffix_attribute(
          suffix_attribute.concat({ id: objId, value: obj, label: obj })
        );
      }
      if (inputId === "partnerRolesArr") {
        setPartnerRolesArr(
          partnerRolesArr.concat({ id: objId, value: obj, label: obj })
        );
      }
      setAddNewFlag(true);
    } else {
      if (inputId === "partnerRolesArr") {
        partnerRolesArr.length = 0;
        setPartnerRolesArr(partnerRolesArr.concat(obj));
      }
      if (inputId === "languages_attributes") {
        languages_attribute.length = 0;
        setLanguages_attribute(languages_attribute.concat(obj));
      }
      if (inputId === "partner_candidate_statuses") {
        candidateStatus_attribute.length = 0;
        setCandidateStatus_attribute(candidateStatus_attribute.concat(obj));
      }
      if (inputId === "nationality_list_ids") {
        nationality_list_attribute.length = 0;
        setNationality_list_attribute(nationality_list_attribute.concat(obj));
      }
      if (inputId === "suffix_attributes") {
        suffix_attribute.length = 0;
        setSuffix_attribute(suffix_attribute.concat(obj));
      }
      if (inputId === "organisation_panels_attributes") {
        organisationPanelsAttribute.length = 0;
        setOrganisationPanelsAtribute(organisationPanelsAttribute.concat(obj));
      }
      if (inputId === "source_2_referring_company") {
        source_2_referring_company_attribute.length = 0;
        setSource_2_referring_company_attribute(
          source_2_referring_company_attribute.concat(obj)
        );
      }
      if (inputId === "source_3_referring_company") {
        source_3_referring_company_attribute.length = 0;
        setSource_3_referring_company_attribute(
          source_3_referring_company_attribute.concat(obj)
        );
      }
    }
  };
  const reformatedCompanies = ReviewArr.reduce((akku, row) => {
    const companyRows: any = [];
    row.options.map((name) => {
      companyRows.push({
        type: row.label,
        name: name.value,
      });
    });
    akku = akku.concat(companyRows);
    return akku;
  }, []);

  useEffect(() => {
    if (!addNewFlag && partnerRolesArr.length === 0) {
      setTimeout(() => {
        getRoles();
      }, 100);
    }
    !addNewFlag && getRoles();
    // getBasicInfo();
  }, [global_data.partner_profile]);

  const getBasicInfo = (responseData: any) => {
    const partnerUserData: any = globaluserData?.userData;
    console.log("partnerUserData", partnerUserData);
    if (role === "admin") {
      if (!addNewFlag && global_data?.partner_profile !== null) {
        setLoading(true);
        getBasicInfoById(global_data?.partner_profile, responseData);
      }
      setPartnerListingData(responseData[mappedKeyJSON.Role]);
    } else {
      setLoading(true);
      getBasicInfoById(partnerUserData?.partner_profile_id, responseData);
    }
  };

  const getBasicInfoById = (id: any, responseData: any) => {
    AdminPartnerClient.BasicInfo_get("", id)
      .then((response: any) => {
        dispatch({
          type: GLOBAL_DATA,
          payload: { name: response?.data.first_name },
        });
        dispatch({
          type: GLOBAL_STEPPER_DATA,
          payload: {
            associate_coaches_id: response.partner_associate_coache_id,
            assessment_profile_id: response.partner_assessment_profile_id,
            coaching_profile_field_id: response.partner_coaching_profile_id,
            partner_panel_access_id: response.partner_panel_access_id,
            partner_share_login_credential_ids:
              response.partner_share_login_credential_ids,
            partner_nda_id: response.partner_nda_id,
            partner_wwa_id: response.partner_wwa_id,
            partner_contract_document_id: response.partner_contract_document_id,
            Commision_admin_id: response.partner_commission_information_id,
            due_diligence_id: response.partner_due_diligence_call_id,
            extraQuestion_id: response.partner_extra_question_id,
            facilitation_profile_id: response.partner_facilitation_profile_id,
            gdprs_id: response.partner_gdpr_id,
            mentoring_profile_id: response.partner_mentoring_profile_id,
            quality_assurance_id: response.partner_quality_assurance_id,
            questionnaire_id: response.partner_questionaire_id,
            ranking_id: response.partner_ranking_id,
            partner_reference_ques_id: response.partner_reference_qas_id,
            review_id: response.partner_review_id,
            general_profile_id: response.partner_general_profile_id,
            work_id: response.partner_work_id,
            partner_profile: response.data.id,
            updated_at: response.data.updated_at,
            modified_by: response.data.modified_by,
            created_at: response.data.created_at,
            created_by: response.data.created_by,
            first_name: response.data.first_name,
            last_name: response.data.last_name,
            questionnaire_flag: response.data.open_questionnaire_section,
            acuity_profile_create: response.data.acuity_profile_create,
            next_available_date: response.data.next_available_date,
            no_of_assignment: response.data.no_of_assignment,
            last_assignment_date: response.data.last_assignment_date,
            coaching_hr_id: response.data.coaching_hr_id,
            currently_available_for_assignment:
              response.data.currently_available_for_assignment,
          },
        });
        setUserData((prevValues: any) => ({
          ...prevValues,
          next_available_date: response.data.next_available_date,
          first_name: response.data.first_name,
          middle_name: response.data.middle_name,
          last_name: response.data.last_name,
          full_name: response.data.full_name,
          email: response.data.email,
          company_name: response.data.company_name,
          phone: response.data.phone,
          initial_contact_date: response.data.initial_contact_date,
          contact_location: response.data.contact_location,
          referred_by: response.data.referred_by,
          sourced_for: response.data.sourced_for,
          sourced1: StepperService.getValueFromArrById(
            responseData[mappedKeyJSON.SourceReferral1Id],
            response.data.source_referral1_id
          ),
          // sourced1: response.data.source_referral1_id,
          associate_coach: response.data.associate_coach,
          associate_role: response.data.associate_role,
          associate_bio: response.data.associate_bio,
          organisation_name: response.data.organisation_name,
          country_list_id: response.data.country,
          general_internal_comment: response.data.general_internal_comment,
          access_level:
            response.data.access_level == null
              ? ""
              : response.data.access_level,
          facebook: response.data.facebook,
          linkedin: response.data.linkedin,
          secondary_email: response.data.secondary_email,
          skype: response.data.skype,
          twitter: response.data.twitter,
          currently_available_for_assignment:
            response.data.currently_available_for_assignment !== ""
              ? response.data.currently_available_for_assignment
              : "",
          service_authorisation:
            response.data.service_authorisation != null
              ? !response.data.service_authorisation
                ? "false"
                : "true"
              : "",
          resume_boolean:
            response.data.resume_boolean != null
              ? !response.data.resume_boolean
                ? "false"
                : "true"
              : "",
          bame:
            response.data.bame != null
              ? !response.data.bame
                ? "false"
                : "true"
              : "",
          open_questionnaire_section:
            response.data.open_questionnaire_section != null
              ? !response.data.open_questionnaire_section
                ? "false"
                : "true"
              : "",
          acuity_profile_create:
            response.data.acuity_profile_create != null
              ? !response.data.acuity_profile_create
                ? "false"
                : "true"
              : "",
          diversity_inclusion:
            response.data.diversity_inclusion != null
              ? !response.data.diversity_inclusion
                ? "false"
                : "true"
              : "",
          source_referral3_id: StepperService.getValueFromArrById(
            responseData[mappedKeyJSON.SourceReferral3Id],
            response.data.source_referral3_id
          ),
          authorisation_provided_by: response.data.authorisation_provided_by,
          telephone: response.data.telephone,
          website: response.data.website,
          website2: response.data.website2,
          visa_status: response.data.visa_status,
          document: response.data.document,
          address: response.data.address,
          address_line1: response.data.address_line1,
          address_line2: response.data.address_line2,
          zipcode: response.data.zipcode,
          city: response.data.city,
          county: response.data.county,
          person_status_id: StepperService.getValueFromArrById(
            responseData[mappedKeyJSON.PersonStatus],
            response.data.person_status_id
          ),
          title: StepperService.getValueFromArrById(
            responseData[mappedKeyJSON.Title],
            response.data.title_id
          ),
          country: StepperService.getValueFromArrById(
            responseData[mappedKeyJSON.Country],
            response.data.country
          ),
          gender: StepperService.getValueFromArrById(
            responseData[mappedKeyJSON.Gender],
            response.data.gender_id
          ),
          gender_text: response.data.gender_text,
          source: StepperService.getValueFromArrById(
            responseData[mappedKeyJSON.Source],
            response.data.source_id
          ),

          pa_name: response.data.pa_name,
          pa_contact_details: response.data.pa_contact_details,
          office_address: response.data.office_address,
          business_address_line1: response.data.business_address_line1,
          business_address_line2: response.data.business_address_line2,
          business_city: response.data.business_city,
          business_country_list_id: StepperService.getValueFromArrById(
            responseData[mappedKeyJSON.BusinessCountry],
            response.data.business_country_list_id
          ),
          business_zipcode: response.data.business_zipcode,
          business_postcode: response.data.business_postcode,
          business_phone: response.data.business_phone,
          business_mobile_number: response.data.business_mobile_number,
          location_radius: response.data.location_radius,
          business_county: response.data.business_county,
          fluency_id: response.data.fluency_id,
        }));
        StepperService.getValueFromArrayForCombobox1(
          response.data.organisation_panels,
          responseData[mappedKeyJSON.OrganisationPanels],
          setOrganisationPanelsAtribute,
          organisationPanelsAttribute
        );
        StepperService.getValueFromArrayForCombobox1(
          response.data.partner_languages,
          responseData[mappedKeyJSON.Language],
          setLanguages_attribute,
          languages_attribute
        );
        StepperService.getValueFromArrayForCombobox1(
          response.data.suffix_id,
          responseData[mappedKeyJSON.Suffix],
          setSuffix_attribute,
          suffix_attribute
        );
        StepperService.getValueFromArrayForCombobox1(
          response.data.nationality_list_ids,
          responseData[mappedKeyJSON.Country],
          setNationality_list_attribute,
          nationality_list_attribute
        );
        StepperService.getValueFromArrayForCombobox1(
          response.data.partner_roles,
          responseData[mappedKeyJSON.Role],
          setPartnerRolesArr,
          partnerRolesArr,
          dispatch,
          "role",
          global_data
        );
        StepperService.getValueFromArrayForCombobox1(
          response.data.source_referral2_id,
          responseData[mappedKeyJSON.OrganisationPanels],
          setSource_2_referring_company_attribute,
          source_2_referring_company_attribute
        );
        StepperService.getValueFromArrayForCombobox1(
          response.data.source_referral3_id,
          responseData[mappedKeyJSON.SourceReferral3Id],
          setSource_3_referring_company_attribute,
          source_3_referring_company_attribute
        );
        setPartnerListingData(responseData[mappedKeyJSON.Role]);
        setCandidateStatus_attribute(
          response.data.partner_candidate_statuses.length > 0
            ? response.data.partner_candidate_statuses
            : []
        );

        if (response.data.passport.length > 0) {
          passportArr.length = 0;
          var localPassportArr: any = [];
          response.data.passport.map((options: any) => {
            var pdata = {
              attributes: {
                created_at: options.created_at,
                file_name: options.file_name,
                url: options.document.url,
                id: options.id,
              },
            };
            localPassportArr.push(pdata);
          });
          setPassportArr(passportArr.concat(localPassportArr));
        }
        if (response.data.resume.length > 0) {
          dataArr.length = 0;
          var localDataArr: any = [];
          response.data.resume.map((options: any) => {
            var pdata = {
              attributes: {
                created_at: options.created_at,
                file_name: options.file_name,
                url: options.resume.url,
                id: options.id,
              },
            };
            localDataArr.push(pdata);
          });
          setDataArr(dataArr.concat(localDataArr));
        }
        if (response.data.visa.length > 0) {
          dataArr.length = 0;
          var localVisaArr: any = [];
          response.data.visa.map((options: any) => {
            var pdata = {
              attributes: {
                created_at: options.created_at,
                file_name: options.file_name,
                url: options.document.url,
                id: options.id,
              },
            };
            localVisaArr.push(pdata);
          });
          setVisaArr(visaArr.concat(localVisaArr));
        }

        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const getRoles = () => {
    AdminPartnerClient.dropdown_get("listingDropdowns").then(
      (response: any) => {
        dispatch({
          type: GLOBAL_DATA,
          payload: { partnerDropdowns: response },
        });
        StepperService.setCompDataArr(
          response[mappedKeyJSON.Gender],
          setGenderArr,
          genderArr
        );
        StepperService.setCompDataArr(
          response[mappedKeyJSON.Title],
          setTitleArr,
          titleArr
        );
        StepperService.setCompDataArr(
          response[mappedKeyJSON.Fluency],
          setFluencyArr,
          fluencyArr
        );
        StepperService.setCompDataArr(
          response[mappedKeyJSON.Country],
          setCountryListsArr,
          countryListsArr
        );
        StepperService.setCompDataArr(
          response[mappedKeyJSON.BusinessCountry],
          setBusinessCountryListsArr,
          businessCountryListsArr
        );
        StepperService.setCompDataArr(
          response[mappedKeyJSON.SourceReferral1Id],
          setSource_1_referring,
          source_1_referring
        );
        StepperService.setCompDataArr(
          response[mappedKeyJSON.City],
          setCityListsArr,
          cityListsArr
        );
        StepperService.setCompDataArr(
          response[mappedKeyJSON.City],
          setLevelListsArr,
          levelListsArr
        );
        StepperService.setCompDataArr(
          response[mappedKeyJSON.Source],
          setSourceArr,
          sourceArr
        );
        StepperService.setCompDataArr(
          response[mappedKeyJSON.PersonStatus],
          setPersonStatusArr,
          personStatusArr
        );
        StepperService.setCompDataArr(
          response[mappedKeyJSON.County],
          setCountyListsArr,
          countyListsArr
        );
        languageListsArr.length = 0;
        setLanguageListsArr(
          languageListsArr.concat(response[mappedKeyJSON.Language])
        );
        candidateStatusArr.length = 0;
        setCandidateStatusArr(
          candidateStatusArr.concat(
            response[mappedKeyJSON.CandidateStatusByGroup]
          )
        );
        suffixArr.length = 0;

        var pdata = [
          ...response[mappedKeyJSON.Suffix],
          { id: response[mappedKeyJSON.Suffix].length, value: "+ Add New" },
        ];
        setSuffixArr(suffixArr.concat(pdata));
        organisationPanelsArr.length = 0;
        setOrganisationPanelsArr(
          organisationPanelsArr.concat(
            response[mappedKeyJSON.OrganisationPanels]
          )
        );

        source_3_referring_companyArr.length = 0;
        setSource_3_referring_companyArr(
          source_3_referring_companyArr.concat(
            response[mappedKeyJSON.SourceReferral3Id]
          )
        );

        nationalityArr.length = 0;
        setNationalityArr(
          nationalityArr.concat(response[mappedKeyJSON.Country])
        );
        partnerDummyRoleArr.length = 0;
        var pdata = [
          ...response[mappedKeyJSON.Role],
          { id: response[mappedKeyJSON.Role].length, value: "+ Add New" },
        ];
        setPartnerDummyRoleArr(partnerDummyRoleArr.concat(pdata));
        // if (userData.first_name == "") {
        getBasicInfo(response);
        // }
      }
    );
  };
  const [valuedAdded, setValueAdded] = useState({ added: false, value: null });
  const firstElementRef = useRef(null);
  useEffect(() => {
    window.scrollTo(0, 0);
    if (firstElementRef.current) {
      //@ts-ignore
      firstElementRef.current.scrollIntoView();
    }
  }, []);
  useEffect(() => {
    if (valuedAdded?.added) {
      setValueAdded({ added: false, value: null });
      setTimeout(getRoles, 1000);
    }
  }, [global_data_common.partnerDropdowns, valuedAdded.added]);
  const onSubmit = () => {
    var flag = true;
    if (
      userData.first_name === "" ||
      userData.last_name === "" ||
      userData.phone === "" ||
      userData.phone.toString().length < 4 ||
      userData.email === "" ||
      partnerRolesArr.length === 0 ||
      nationality_list_attribute.length === 0 ||
      userData.telephone === "" ||
      userData.telephone.length < 4
    ) {
      flag = false;
    }
    if (
      role === "admin" &&
      (userData.person_status_id === "" ||
        userData.initial_contact_date === null ||
        userData?.initial_contact_date?.length === 0 ||
        userData.acuity_profile_create === "" ||
        userData.sourced1 === "" ||
        userData.sourced_for === "" ||
        userData.resume_boolean === "" ||
        userData.sourced1 === "" ||
        source_2_referring_company_attribute === "" ||
        source_3_referring_company_attribute.length === 0 ||
        (userData.resume_boolean === "true" && dataArr.length === 0))
    ) {
      flag = false;
    }
    if (
      role !== "admin" &&
      (userData.business_city === "" ||
        userData.business_postcode === "" ||
        userData.business_phone === "" ||
        userData.business_phone.length < 4 ||
        userData.business_mobile_number === "" ||
        userData.business_mobile_number.length < 4 ||
        userData.business_country_list_id === "" ||
        languages_attribute.length === 0 ||
        // userData.business_zipcode == "" ||
        userData.telephone === "" ||
        userData.business_county === "" ||
        userData.office_address === "")
    ) {
      flag = false;
    }

    if (global_data.partner_profile === "" && userData.email !== "") {
      var pattern = new RegExp(
        /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
      );
      if (!pattern.test(userData.email)) {
        flag = false;
        setEmailInvalidFlag(true);
      }
    }

    if (flag) {
      setSubmitClickFlag(false);
      var docResumeArr: any = [],
        docvisaArr: any = [],
        docpassArr: any = [];
      dataArr.map((option: any) => {
        option.attributes.document &&
          docResumeArr.push(option.attributes.document);
      });
      visaArr.map((option: any) => {
        option.attributes.document &&
          docvisaArr.push(option.attributes.document);
      });
      passportArr.map((option: any) => {
        option.attributes.document &&
          docpassArr.push(option.attributes.document);
      });

      var langArr: any = [],
        suffixArr: any = [],
        localRoleArr: any = [],
        organisationPanelArr: any = [],
        sourceRef2Arr: any = [],
        sourceRef3Arr: any = [],
        localCandidateStatus: any = [],
        nationality_listArr: any = [];
      languages_attribute.length > 0 &&
        languages_attribute.map((option: any) => langArr.push(option.id));
      suffix_attribute?.length > 0 &&
        suffix_attribute?.map((option: any) =>
          suffixArr.push(option?.id || "")
        );
      nationality_list_attribute.length > 0 &&
        nationality_list_attribute.map((option: any) =>
          nationality_listArr.push(option.id)
        );
      organisationPanelsAttribute.length > 0 &&
        organisationPanelsAttribute.map((option: any) =>
          organisationPanelArr.push(option.id)
        );
      partnerRolesArr.length > 0 &&
        partnerRolesArr.map((option: any) => localRoleArr.push(option.id));
      source_2_referring_company_attribute.length > 0 &&
        source_2_referring_company_attribute.map((option: any) =>
          sourceRef2Arr.push(option.id)
        );
      source_3_referring_company_attribute.length > 0 &&
        source_3_referring_company_attribute.map((option: any) =>
          sourceRef3Arr.push(option.id)
        );
      candidateStatus_attribute.length > 0 &&
        candidateStatus_attribute.map((option: any) =>
          localCandidateStatus.push(option.id)
        );
      var gender_id_local = StepperService.getSelectedIdFromArr(
        global_data_common.partnerDropdowns[mappedKeyJSON.Gender],
        userData.gender
      );
      var postData = {
        ...userData,
        source_referral1_id: StepperService.getSelectedIdFromArr(
          global_data_common.partnerDropdowns[mappedKeyJSON.SourceReferral1Id],
          userData.sourced1
        ),
        source_referral3_id:
          sourceRef3Arr.length > 0 ? JSON.stringify(sourceRef3Arr) : "[]",

        person_status_id: StepperService.getSelectedIdFromArr(
          global_data_common.partnerDropdowns[mappedKeyJSON.PersonStatus],
          userData.person_status_id
        ),
        source_id: StepperService.getSelectedIdFromArr(
          global_data_common.partnerDropdowns[mappedKeyJSON.Source],
          userData.source
        ),
        title_id: StepperService.getSelectedIdFromArr(
          global_data_common.partnerDropdowns[mappedKeyJSON.Title],
          userData.title
        ),
        suffix_id: suffixArr.length > 0 ? JSON.stringify(suffixArr) : "[]",
        nationality_list_ids:
          nationality_listArr.length > 0
            ? JSON.stringify(nationality_listArr)
            : "[]",
        gender_id: gender_id_local != "[]" ? gender_id_local : 0,
        country_list_id: StepperService.getSelectedIdFromArr(
          global_data_common.partnerDropdowns[mappedKeyJSON.Country],
          userData.country
        ),
        business_country_list_id: StepperService.getSelectedIdFromArr(
          global_data_common.partnerDropdowns[mappedKeyJSON.Country],
          userData.business_country_list_id
        ),
        language_list_id: langArr.length > 0 ? JSON.stringify(langArr) : "[]",
        source_referral2_id:
          sourceRef2Arr.length > 0 ? JSON.stringify(sourceRef2Arr) : "[]",
        organisation_panels:
          organisationPanelArr.length > 0
            ? JSON.stringify(organisationPanelArr)
            : "[]",
        partner_roles_attributes: JSON.stringify(localRoleArr),
        partner_resumes_attributes: docResumeArr,
        visa: docvisaArr,
        passport: docpassArr,
        partner_candidate_statuses:
          candidateStatus_attribute.length > 0
            ? JSON.stringify(candidateStatus_attribute)
            : "[]",
      };
      setLoading(true);
      if (global_data.partner_profile == null) {
        AdminPartnerClient.BasicInfo(
          ObjectToFormdata({
            ...postData,
          })
        )
          .then((response: any) => {
            if (response.data) {
              props.parentSetProfileId(
                response.data.id,
                response.data.acuity_people_profile_id
              );

              dispatch({
                type: GLOBAL_STEPPER_DATA,
                payload: {
                  partner_profile: response.data.id,
                  questionnaire_flag: response.data.open_questionnaire_section,
                },
              });
              dispatch({
                type: GLOBAL_DATA,
                payload: {
                  name: response.data.first_name,
                  next_available_date: response.data.next_available_date,
                },
              });
              dispatch(
                showSnackbar("Success", ["Information saved successfully"])
              );
              StepperService.getValueFromArrayForCombobox1(
                response.data.partner_roles,
                partnerListingData,
                setPartnerRolesArr,
                partnerRolesArr,
                dispatch,
                "role",
                global_data
              );
              props.parentHandleNext(props.activeIndex + 1);
            } else {
              dispatch(showSnackbar("Error", [response?.message]));
            }
            setLoading(false);
          })
          .catch((error) => {
            setLoading(false);
            dispatch(showSnackbar("Error", [error.errors]));
          });
      } else {
        AdminPartnerClient.BasicInfo_put(
          global_data.partner_profile,
          ObjectToFormdata({ ...postData })
        )
          .then((response: any) => {
            if (response.data) {
              dispatch({
                type: GLOBAL_STEPPER_DATA,
                payload: {
                  questionnaire_flag: response.data.open_questionnaire_section,
                },
              });
              dispatch(
                showSnackbar("Success", ["Information updated successfully"])
              );
              StepperService.getValueFromArrayForCombobox1(
                response.data.partner_roles,
                partnerListingData,
                setPartnerRolesArr,
                partnerRolesArr,
                dispatch,
                "role",
                global_data
              );
              props.parentHandleNext(props.activeIndex + 1);
            } else {
              dispatch(showSnackbar("Error", [response?.message]));
            }
            setLoading(false);
          })
          .catch((error) => {
            setLoading(false);
            dispatch(
              showSnackbar("Error", [
                error?.errors?.user || error?.errors?.email[0],
              ])
            );
          });
      }
    } else {
      setSubmitClickFlag(true);
    }
  };
  const onImageChange = (event: any, id: any) => {
    var localArr = [];
    var pdata = {
      attributes: {
        document: event.target.files[0],
        created_at: "2021-04-08T12:06:08.000Z",
        file_name: event.target.files[0].name,
        id:
          id === "resume"
            ? dataArr.length + 1
            : id === "visa"
            ? visaArr.length + 1
            : passportArr.length + 1,
      },
    };
    localArr.push(pdata);
    id === "resume" && setDataArr(dataArr.concat(localArr));
    id === "visa" && setVisaArr(visaArr.concat(localArr));
    id === "passport" && setPassportArr(passportArr.concat(localArr));
  };

  const handleChange = (event: any, newValue: any) => {
    setUserData({ ...userData, location_radius: newValue });
  };

  const handleCityList = (value: any) => {
    var cityLocalArr: any = [];

    DataService.getData({ country: value }, "listing_cities").then(
      (res: any) => {
        const city_list = res.cities.map((item: any, index: any) => ({
          value: item,
          id: index,
        }));
        res.cities.length > 0 &&
          city_list.map((option: any) => {
            cityLocalArr.push(option.value);
          });
        cityListsArr.length = 0;
        setCityListsArr(cityListsArr.concat(cityLocalArr));
      }
    );
  };

  const toggleAddress = (value: any) => {
    var pdata = {};
    if (value) {
      pdata = {
        office_address: userData.address,
        business_address_line1: userData.address_line1,
        business_address_line2: userData.address_line2,
        business_city: userData.city,
        business_county: userData.county,
        business_postcode: userData.zipcode,
        business_country_list_id: userData.country,
      };
    } else {
      pdata = {
        office_address: userData.office_address,
        business_address_line1: userData.business_address_line1,
        business_address_line2: userData.business_address_line2,
        business_city: userData.business_city,
        business_county: userData.business_county,
        business_postcode: userData.business_postcode,
        business_country_list_id: userData.business_country_list_id,
      };
    }
    setUserData({ ...userData, ...pdata });
    setCopyFlag(value);
  };
  return (
    <div ref={firstElementRef}>
      {
        <>
          <Grid
            container
            direction="row"
            alignItems="center"
            style={{ padding: 30, marginBottom: 40 }}
          >
            <Grid item xs={10}>
              <Grid
                container
                direction="row"
                alignItems="center"
                style={{ marginBottom: 20 }}
              >
                <Grid item xs={4}>
                  <Typography variant="h2">Title</Typography>
                </Grid>
                <Grid item xs={4}>
                  <CustomSelect
                    autoFocus
                    id="title"
                    labelText="Select title"
                    displayEmpty
                    variant="outlined"
                    itemArr={titleArr}
                    parentcall={onChangeItem}
                    defaultValue={userData.title}
                  />
                </Grid>
              </Grid>
              <Grid
                container
                direction="row"
                alignItems="center"
                style={{ marginBottom: 20 }}
              >
                <Grid item xs={4}>
                  <Typography variant="h2">First name*</Typography>
                </Grid>
                <Grid item xs={8}>
                  <CustomInput
                    id="first_name"
                    variant="outlined"
                    placeholder="First name"
                    helperText={
                      submitClickFlag && userData.first_name === ""
                        ? "* Please enter first name"
                        : ""
                    }
                    error={
                      submitClickFlag && userData.first_name === ""
                        ? true
                        : false
                    }
                    parentcall={setInputState}
                    value={userData.first_name}
                  />
                </Grid>
              </Grid>
              <Grid
                container
                direction="row"
                alignItems="center"
                style={{ marginBottom: 20 }}
              >
                <Grid item xs={4}>
                  <Typography variant="h2">Middle name</Typography>
                </Grid>
                <Grid item xs={8}>
                  <CustomInput
                    id="middle_name"
                    variant="outlined"
                    placeholder="Middle name"
                    helperText={
                      submitClickFlag && userData.middle_name === "" ? " " : ""
                    }
                    parentcall={setInputState}
                    value={userData.middle_name}
                  />
                </Grid>
              </Grid>
              <Grid
                container
                direction="row"
                alignItems="center"
                style={{ marginBottom: 20 }}
              >
                <Grid item xs={4}>
                  <Typography variant="h2">Last name*</Typography>
                </Grid>
                <Grid item xs={8}>
                  <CustomInput
                    id="last_name"
                    variant="outlined"
                    placeholder="Last name"
                    helperText={
                      submitClickFlag && userData.last_name === ""
                        ? "* Please enter last name"
                        : ""
                    }
                    error={
                      submitClickFlag && userData.last_name === ""
                        ? true
                        : false
                    }
                    parentcall={setInputState}
                    value={userData.last_name}
                  />
                </Grid>
              </Grid>
              <Grid
                container
                direction="row"
                alignItems="center"
                style={{ marginBottom: 20 }}
              >
                <Grid item xs={4}>
                  <Typography variant="h2">Full Name</Typography>
                </Grid>
                <Grid item xs={8}>
                  <CustomInput
                    disabled
                    id="full_name"
                    variant="outlined"
                    placeholder="Full name"
                    value={
                      userData.first_name !== ""
                        ? `${userData.first_name} ${userData.middle_name} ${userData.last_name}`
                        : ""
                    }
                  />
                </Grid>
              </Grid>

              <Grid
                container
                direction="row"
                alignItems="center"
                style={{ marginBottom: 20 }}
              >
                <Grid item xs={4}>
                  <Typography variant="h2">Suffix</Typography>
                </Grid>
                <Grid item xs={8}>
                  <CustomSelectMulti
                    id="suffix_attributes"
                    itemArr={suffixArr}
                    drop_down="Suffix"
                    addNewHandler={addNewHandler}
                    field_name="suffix"
                    addNewFlag={true}
                    parentcall={onChangeMultiItem}
                    placeholder="Select suffix"
                    value={suffix_attribute}
                    valuedAdded={valuedAdded}
                    setValueAdded={setValueAdded}
                  />
                </Grid>
              </Grid>
              <Grid
                container
                direction="row"
                alignItems="center"
                style={{ marginBottom: 20 }}
              >
                <Grid item xs={4}>
                  <Typography variant="h2">Company name</Typography>
                </Grid>
                <Grid item xs={8}>
                  <CustomInput
                    id="company_name"
                    variant="outlined"
                    placeholder="Company name"
                    parentcall={setInputState}
                    value={userData.company_name}
                  />
                </Grid>
              </Grid>

              {role === "admin" && (
                <Grid
                  container
                  direction="row"
                  alignItems="center"
                  style={{ marginBottom: 20 }}
                >
                  <Grid item xs={4}>
                    <Typography variant="h2">
                      Person status{role === "admin" ? "*" : ""}
                    </Typography>
                  </Grid>
                  <Grid item xs={8}>
                    <CustomSelect
                      labelText="Select person status"
                      id="person_status_id"
                      displayEmpty
                      variant="outlined"
                      itemArr={personStatusArr}
                      parentcall={onChangeItem}
                      helperText={
                        role === "admin" &&
                        submitClickFlag &&
                        (userData.person_status_id === "" ||
                          userData.person_status_id === undefined)
                          ? "* Please select person status"
                          : ""
                      }
                      error={
                        role === "admin" &&
                        submitClickFlag &&
                        userData.person_status_id === ""
                          ? true
                          : false
                      }
                      defaultValue={userData.person_status_id}
                    />
                  </Grid>
                </Grid>
              )}
              {role === "admin" && (
                <Grid
                  container
                  direction="row"
                  alignItems="center"
                  style={{ marginBottom: 20 }}
                >
                  <Grid item xs={4}>
                    <Typography variant="h2">Candidate status</Typography>
                  </Grid>
                  <Grid item xs={8}>
                    <CustomSelectMulti
                      id="partner_candidate_statuses"
                      itemArr={candidateStatusArr}
                      grouped={true}
                      parentcall={onChangeMultiItem}
                      placeholder="Select candidate status"
                      value={candidateStatus_attribute}
                    />
                  </Grid>
                </Grid>
              )}
              <Grid
                container
                direction="row"
                alignItems="center"
                style={{ marginBottom: 20, position: "relative" }}
              >
                <Grid item xs={4}>
                  <Typography variant="h2">Nationality*</Typography>
                </Grid>

                <Grid item xs={8}>
                  <CustomSelectMulti
                    id="nationality_list_ids"
                    itemArr={nationalityArr}
                    parentcall={onChangeMultiItem}
                    placeholder="Select nationality"
                    value={nationality_list_attribute}
                    helperText={
                      submitClickFlag && nationality_list_attribute.length === 0
                        ? "* Please select nationality"
                        : ""
                    }
                    error={
                      submitClickFlag && nationality_list_attribute.length === 0
                        ? true
                        : false
                    }
                  />
                </Grid>
              </Grid>
              <Grid
                container
                direction="row"
                alignItems="center"
                style={{ marginBottom: 20 }}
              >
                <Grid item xs={4}>
                  <Typography variant="h2">Gender</Typography>
                </Grid>
                <Grid item xs={8}>
                  <CustomSelect
                    id="gender"
                    labelText="Select gender"
                    displayEmpty
                    variant="outlined"
                    itemArr={genderArr}
                    parentcall={onChangeItem}
                    defaultValue={userData.gender}
                  />
                  {userData.gender === "Other" && (
                    <CustomInput
                      style={{ marginTop: 10 }}
                      id="gender_text"
                      variant="outlined"
                      placeholder="Others"
                      parentcall={setInputState}
                      value={userData.gender_text}
                      helperText="Please state"
                    />
                  )}
                </Grid>
              </Grid>
              <Grid
                container
                direction="row"
                alignItems="center"
                style={{ marginBottom: 20 }}
              >
                <Grid item xs={4}>
                  <Typography variant="h2">Type of partner*</Typography>
                </Grid>
                <Grid item xs={8}>
                  <CustomSelectMulti
                    id="partnerRolesArr"
                    itemArr={partnerDummyRoleArr}
                    drop_down="ProfileRole"
                    addNewHandler={addNewHandler}
                    field_name="title"
                    addNewFlag={true}
                    valuedAdded={valuedAdded}
                    setValueAdded={setValueAdded}
                    parentcall={onChangeMultiItem}
                    placeholder="Select type of partner"
                    helperText={
                      submitClickFlag && partnerRolesArr.length === 0
                        ? "* Please select partner type"
                        : ""
                    }
                    error={
                      submitClickFlag && partnerRolesArr.length === 0
                        ? true
                        : false
                    }
                    value={partnerRolesArr}
                  />
                </Grid>
              </Grid>

              {role === "admin" && (
                <Grid
                  container
                  direction="row"
                  alignItems="center"
                  style={{ marginBottom: 20 }}
                >
                  <Grid item xs={4}>
                    <Typography variant="h2">Access level</Typography>
                  </Grid>
                  <Grid item xs={8}>
                    <CustomSelect
                      id="access_level"
                      labelText="Select access level"
                      displayEmpty
                      variant="outlined"
                      itemArr={[
                        "Level 1",
                        "Level 2",
                        "Level 3",
                        "Level 4",
                        "Level 5",
                        "Level 6",
                      ]}
                      parentcall={onChangeItem}
                      defaultValue={userData.access_level}
                    />
                  </Grid>
                </Grid>
              )}

              {role === "admin" && (
                <Grid
                  container
                  direction="row"
                  alignItems="center"
                  style={{ marginBottom: 20 }}
                >
                  <Grid item xs={4}>
                    <Typography variant="h2">
                      Authorisation to access the service
                    </Typography>
                  </Grid>
                  <Grid item xs={8}>
                    <CustomSelect
                      id="service_authorisation"
                      labelText="Select service authorisation"
                      displayEmpty
                      variant="outlined"
                      itemArr={["Yes", "No"]}
                      parentcall={onChangeItem}
                      defaultValue={
                        userData.service_authorisation !== ""
                          ? userData.service_authorisation === "true"
                            ? "Yes"
                            : "No"
                          : "0"
                      }
                    />
                  </Grid>
                </Grid>
              )}

              {role === "admin" && (
                <Grid
                  container
                  direction="row"
                  alignItems="center"
                  style={{ marginBottom: 20 }}
                >
                  <Grid item xs={4}>
                    <Typography variant="h2">
                      Authorisation provided by
                    </Typography>
                  </Grid>
                  <Grid item xs={8}>
                    <CustomInput
                      id="authorisation_provided_by"
                      variant="outlined"
                      placeholder="Authorisation provided by"
                      parentcall={setInputState}
                      value={userData.authorisation_provided_by}
                    />
                  </Grid>
                </Grid>
              )}

              {role === "admin" && (
                <Grid
                  container
                  direction="row"
                  alignItems="center"
                  style={{ marginBottom: 20 }}
                >
                  <Grid item xs={4}>
                    <Typography variant="h2">Organization panels</Typography>
                  </Grid>
                  <Grid item xs={8}>
                    <CustomSelectMulti
                      id="organisation_panels_attributes"
                      itemArr={organisationPanelsArr}
                      parentcall={onChangeMultiItem}
                      placeholder="Select organization panels"
                      value={organisationPanelsAttribute}
                    />
                  </Grid>
                </Grid>
              )}

              {role === "admin" && (
                <Grid container direction="row" alignItems="center">
                  <Grid item xs={4}>
                    <Typography variant="h2">
                      Date of initial contact *
                    </Typography>
                  </Grid>
                  <Grid item xs={8}>
                    <DateComponent
                      key={"001"}
                      componentObject={{
                        componentType: "datePicker",
                        required: role === "admin" && true,
                        label: "",
                        name: "initial_contact_date",
                        placeholder: "Initial contact date",
                        helperText:
                          role === "admin" &&
                          (submitClickFlag &&
                          (userData?.initial_contact_date === null ||
                            userData?.initial_contact_date.length === 0)
                            ? "* Please select Date of initial contact"
                            : ""),
                        indexKey: "0-0",
                        index: "initial_contact_date",
                        handleChange: setInputState,
                        value: userData.initial_contact_date,
                      }}
                    />
                  </Grid>
                </Grid>
              )}

              {role === "admin" && (
                <Grid
                  container
                  direction="row"
                  alignItems="center"
                  style={{ marginBottom: 20 }}
                >
                  <Grid item xs={4}>
                    <Typography variant="h2">
                      Assignment sourced for *
                    </Typography>
                  </Grid>
                  <Grid item xs={8}>
                    <CustomSelect
                      id="sourced_for"
                      labelText="Select assignment sourced for"
                      displayEmpty
                      variant="outlined"
                      itemArr={["Yes", "No"]}
                      parentcall={onChangeItem}
                      defaultValue={
                        userData.sourced_for !== ""
                          ? userData.sourced_for === "true"
                            ? "Yes"
                            : "No"
                          : "0"
                      }
                      helperText={
                        submitClickFlag && userData?.sourced_for?.length === 0
                          ? "* Please select Assignment sourced for"
                          : ""
                      }
                      error={
                        submitClickFlag && userData?.sourced_for?.length === 0
                          ? true
                          : false
                      }
                    />
                  </Grid>
                </Grid>
              )}

              {role === "admin" && (
                <Grid
                  container
                  direction="row"
                  alignItems="center"
                  style={{ marginBottom: 20 }}
                >
                  <Grid item xs={4}>
                    <Typography variant="h2">
                      Source type{role === "admin" ? "*" : ""}
                    </Typography>
                  </Grid>
                  <Grid item xs={8}>
                    <Autocomplete
                      id="sourced1"
                      options={source_1_referring}
                      getOptionLabel={(option) => option || ""}
                      onInputChange={(e, newValue) => {
                        setInputValue(newValue);
                      }}
                      onChange={(e, data) =>
                        setUserData((prev: any) => ({
                          ...prev,
                          sourced1: data,
                        }))
                      }
                      value={userData.sourced1}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder="Select source type"
                          variant="outlined"
                          className={classes.autoCompleteInput}
                          helperText={
                            role === "admin" &&
                            submitClickFlag &&
                            userData.sourced1 === ""
                              ? "* Please select source type"
                              : ""
                          }
                          error={
                            role === "admin" &&
                            submitClickFlag &&
                            userData.sourced1 === ""
                              ? true
                              : false
                          }
                        />
                      )}
                    />
                  </Grid>
                </Grid>
              )}

              {role === "admin" && (
                <Grid
                  container
                  direction="row"
                  alignItems="center"
                  style={{ marginBottom: 20 }}
                >
                  <Grid item xs={4}>
                    <Typography variant="h2">
                      Source company{role === "admin" ? "*" : ""}
                    </Typography>
                  </Grid>
                  <Grid item xs={8}>
                    <CustomSelectMulti
                      id="source_2_referring_company"
                      itemArr={organisationPanelsArr}
                      parentcall={onChangeMultiItem}
                      placeholder="Select source company"
                      value={source_2_referring_company_attribute}
                      helperText={
                        submitClickFlag &&
                        source_2_referring_company_attribute?.length === 0
                          ? "* Please select Source company"
                          : ""
                      }
                      error={
                        submitClickFlag &&
                        source_2_referring_company_attribute?.length === 0
                          ? true
                          : false
                      }
                    />
                  </Grid>
                </Grid>
              )}

              {role === "admin" && (
                <Grid
                  container
                  direction="row"
                  alignItems="center"
                  style={{ marginBottom: 20 }}
                >
                  <Grid item xs={4}>
                    <Typography variant="h2">
                      Source person{role === "admin" ? "*" : ""}
                    </Typography>
                  </Grid>
                  <Grid item xs={8}>
                    <CustomSelectMulti
                      id="source_3_referring_company"
                      itemArr={source_3_referring_companyArr}
                      parentcall={onChangeMultiItem}
                      placeholder="Select source person"
                      helperText={
                        role === "admin" &&
                        submitClickFlag &&
                        source_3_referring_company_attribute.length === 0
                          ? "Please select source person"
                          : ""
                      }
                      error={
                        role === "admin" &&
                        submitClickFlag &&
                        source_3_referring_company_attribute.length === 0
                          ? true
                          : false
                      }
                      value={source_3_referring_company_attribute}
                    />
                  </Grid>
                </Grid>
              )}

              <Grid
                container
                direction="row"
                alignItems="center"
                style={{ marginBottom: 20 }}
              >
                <Grid item xs={4}>
                  <Typography variant="h2">
                    CV/Resume{role === "admin" ? "*" : ""}
                  </Typography>
                </Grid>
                <Grid item xs={8} container spacing={2}>
                  <Grid item xs={6}>
                    <CustomSelect
                      labelText="Select CV/Resume"
                      id="resume_boolean"
                      displayEmpty
                      variant="outlined"
                      itemArr={["Yes", "No"]}
                      defaultValue={
                        userData.resume_boolean !== ""
                          ? userData.resume_boolean === "true"
                            ? "Yes"
                            : "No"
                          : "0"
                      }
                      parentcall={onChangeItem}
                      helperText={
                        role === "admin" &&
                        submitClickFlag &&
                        !userData.resume_boolean
                          ? "Please upload resume"
                          : ""
                      }
                      error={
                        role === "admin" &&
                        submitClickFlag &&
                        !userData.resume_boolean
                          ? true
                          : false
                      }
                    />
                  </Grid>
                  {userData.resume_boolean === "true" && (
                    <Grid item xs={4}>
                      <label htmlFor="upload-photo-resume">
                        <input
                          onChange={(e) => {
                            onImageChange(e, "resume");
                          }}
                          accept="application/pdf, application/vnd.ms-excel,image/gif, image/jpeg"
                          style={{ display: "none" }}
                          id="upload-photo-resume"
                          name="upload-photo"
                          type="file"
                        />
                        <Button
                          disableElevation
                          color="secondary"
                          variant="contained"
                          component="span"
                          style={{ fontSize: 12 }}
                        >
                          <CloudUpload style={{ marginRight: 10 }} />
                          Upload
                        </Button>
                        {role === "admin" &&
                          submitClickFlag &&
                          dataArr.length === 0 && (
                            <Typography
                              variant="body1"
                              style={{ fontSize: "12px", color: "red" }}
                            >
                              <Box>* Please upload </Box>
                            </Typography>
                          )}
                      </label>
                    </Grid>
                  )}
                </Grid>
              </Grid>
              {userData.resume_boolean === "true" && (
                <Grid container direction="row" alignItems="center">
                  <Grid item xs={4}></Grid>
                  <Grid item xs={8}>
                    {StepperService.uploadImageCard(
                      dataArr,
                      setDataArr,
                      "/partner_profile/destroy_partner_resume/",
                      null,
                      dispatch
                    )}
                  </Grid>
                </Grid>
              )}

              {role === "admin" && (
                <Grid
                  container
                  direction="row"
                  alignItems="center"
                  style={{ marginBottom: 20 }}
                >
                  <Grid item xs={4}>
                    <Typography variant="h2">
                      Send /Open questionnaire section
                    </Typography>
                  </Grid>
                  <Grid item xs={8}>
                    <CustomSelect
                      id="open_questionnaire_section"
                      labelText="Select send /open questionnaire section"
                      displayEmpty
                      variant="outlined"
                      itemArr={["Yes", "No"]}
                      parentcall={onChangeItem}
                      defaultValue={
                        userData.open_questionnaire_section !== ""
                          ? userData.open_questionnaire_section === "true"
                            ? "Yes"
                            : "No"
                          : "0"
                      }
                    />
                  </Grid>
                </Grid>
              )}
              {role === "admin" && (
                <Grid
                  container
                  direction="row"
                  alignItems="center"
                  style={{ marginBottom: 20 }}
                >
                  <Grid item xs={4}>
                    <Typography variant="h2">
                      Acuity profile created *
                    </Typography>
                  </Grid>
                  <Grid item xs={8}>
                    <CustomSelect
                      id="acuity_profile_create"
                      labelText="Select acuity profile created"
                      displayEmpty
                      variant="outlined"
                      itemArr={["Yes", "No"]}
                      parentcall={onChangeItem}
                      defaultValue={
                        userData.acuity_profile_create !== ""
                          ? userData.acuity_profile_create === "true"
                            ? "Yes"
                            : "No"
                          : "0"
                      }
                      helperText={
                        role === "admin" &&
                        submitClickFlag &&
                        !userData.acuity_profile_create
                          ? "* Please select acuity profile created"
                          : ""
                      }
                      error={
                        role === "admin" &&
                        submitClickFlag &&
                        !userData.acuity_profile_create
                          ? true
                          : false
                      }
                    />
                  </Grid>
                </Grid>
              )}
              {role === "admin" && (
                <Grid
                  container
                  direction="row"
                  alignItems="center"
                  style={{ marginBottom: 20 }}
                >
                  <Grid item xs={4}>
                    <Typography variant="h2">BAME</Typography>
                  </Grid>
                  <Grid item xs={8}>
                    <CustomSelect
                      id="bame"
                      displayEmpty
                      labelText="Select BAME"
                      variant="outlined"
                      itemArr={["Yes", "No"]}
                      parentcall={onChangeItem}
                      defaultValue={
                        userData.bame !== ""
                          ? userData.bame === "true"
                            ? "Yes"
                            : "No"
                          : "0"
                      }
                    />
                  </Grid>
                </Grid>
              )}

              {role === "admin" && (
                <Grid
                  container
                  direction="row"
                  alignItems="center"
                  style={{ marginBottom: 20 }}
                >
                  <Grid item xs={4}>
                    <Typography variant="h2">Passport</Typography>
                  </Grid>
                  <Grid item xs={8}>
                    <label htmlFor="upload-photo-passport">
                      <input
                        onChange={(e) => {
                          onImageChange(e, "passport");
                        }}
                        accept="application/pdf, application/vnd.ms-excel,image/gif, image/jpeg"
                        style={{ display: "none" }}
                        id="upload-photo-passport"
                        name="upload-photo"
                        type="file"
                      />
                      <Button
                        disableElevation
                        color="secondary"
                        variant="contained"
                        component="span"
                        style={{ fontSize: 12 }}
                      >
                        <CloudUpload style={{ marginRight: 10 }} />
                        Upload
                      </Button>
                    </label>
                  </Grid>
                </Grid>
              )}

              {role === "admin" && (
                <Grid container direction="row" alignItems="center">
                  <Grid item xs={4}></Grid>
                  <Grid item xs={8}>
                    {StepperService.uploadImageCard(
                      passportArr,
                      setPassportArr,
                      "partner_profile/partner_personal_docs/",
                      null,
                      dispatch
                    )}
                  </Grid>
                </Grid>
              )}

              {role === "admin" && (
                <Grid
                  container
                  direction="row"
                  alignItems="center"
                  style={{ marginBottom: 20 }}
                >
                  <Grid item xs={4}>
                    <Typography variant="h2">Visa</Typography>
                  </Grid>
                  <Grid item xs={8}>
                    <label htmlFor="upload-photo-visa">
                      <input
                        onChange={(e) => {
                          onImageChange(e, "visa");
                        }}
                        accept="application/pdf, application/vnd.ms-excel,image/gif, image/jpeg"
                        style={{ display: "none" }}
                        id="upload-photo-visa"
                        name="upload-photo"
                        type="file"
                      />
                      <Button
                        disableElevation
                        color="secondary"
                        variant="contained"
                        component="span"
                        style={{ fontSize: 12 }}
                      >
                        <CloudUpload style={{ marginRight: 10 }} />
                        Upload
                      </Button>
                    </label>
                  </Grid>
                </Grid>
              )}

              {role === "admin" && (
                <Grid container direction="row" alignItems="center">
                  <Grid item xs={4}></Grid>
                  <Grid item xs={8}>
                    {StepperService.uploadImageCard(
                      visaArr,
                      setVisaArr,
                      "partner_profile/partner_personal_docs/",
                      null,
                      dispatch
                    )}
                  </Grid>
                </Grid>
              )}
              {role === "admin" && (
                <Grid
                  container
                  direction="row"
                  alignItems="center"
                  style={{ marginBottom: 20 }}
                >
                  <Grid item xs={4}>
                    <Typography variant="h2">Visa status</Typography>
                  </Grid>
                  <Grid item xs={8}>
                    <CustomInput
                      id="visa_status"
                      variant="outlined"
                      placeholder="Visa status"
                      parentcall={setInputState}
                      value={userData.visa_status}
                    />
                  </Grid>
                </Grid>
              )}

              <Grid
                container
                direction="row"
                alignItems="center"
                style={{ marginBottom: 20 }}
              >
                <Grid item xs={4}>
                  <Typography variant="h2">
                    Languages{role !== "admin" ? "*" : ""}
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <CustomSelectMulti
                    id="languages_attributes"
                    itemArr={languageListsArr}
                    parentcall={onChangeMultiItem}
                    placeholder="Select languages"
                    helperText={
                      role !== "admin" &&
                      submitClickFlag &&
                      languages_attribute.length === 0
                        ? "Please select languages"
                        : ""
                    }
                    error={
                      role !== "admin" &&
                      submitClickFlag &&
                      languages_attribute.length === 0
                        ? true
                        : false
                    }
                    value={languages_attribute}
                  />
                </Grid>
              </Grid>
              {role === "admin" && (
                <Grid container direction="row" style={{ marginBottom: 20 }}>
                  <Grid item xs={4}>
                    <Typography variant="h2" style={{ paddingTop: "8px" }}>
                      Address
                    </Typography>
                  </Grid>
                  <Grid item xs={8}>
                    <Grid
                      container
                      direction="row"
                      alignItems="center"
                      style={{ marginBottom: 20 }}
                    >
                      <Grid item xs={12}>
                        <CustomInput
                          id="address"
                          variant="outlined"
                          placeholder="Address"
                          parentcall={setInputState}
                          value={userData.address}
                        />
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      direction="row"
                      alignItems="center"
                      style={{ marginBottom: 20 }}
                    >
                      <Grid item xs={12}>
                        <CustomInput
                          id="address_line1"
                          variant="outlined"
                          placeholder="Address line 1"
                          parentcall={setInputState}
                          value={userData.address_line1}
                        />
                      </Grid>
                    </Grid>

                    <Grid
                      container
                      direction="row"
                      alignItems="center"
                      style={{ marginBottom: 20 }}
                    >
                      <Grid item xs={12}>
                        <CustomInput
                          id="address_line2"
                          variant="outlined"
                          placeholder="Address line 2"
                          value={userData.address_line2}
                          parentcall={setInputState}
                        />
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      direction="row"
                      alignItems="center"
                      style={{ marginBottom: 20 }}
                    >
                      <Grid item xs={12}>
                        <CustomInput
                          id="city"
                          variant="outlined"
                          placeholder="City/town"
                          parentcall={setInputState}
                          value={userData.city}
                        />
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      direction="row"
                      alignItems="center"
                      style={{ marginBottom: 20 }}
                    >
                      <Grid item xs={12}>
                        <CustomInput
                          id="county"
                          variant="outlined"
                          placeholder="County/state/region"
                          parentcall={setInputState}
                          value={userData.county}
                        />
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      direction="row"
                      alignItems="center"
                      spacing={2}
                    >
                      <Grid item xs={6}>
                        <CustomInput
                          id="zipcode"
                          variant="outlined"
                          placeholder="Post/zip code"
                          parentcall={setInputState}
                          value={userData.zipcode}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <CustomSelect
                          id="country"
                          labelText="Select country"
                          displayEmpty
                          variant="outlined"
                          itemArr={countryListsArr}
                          parentcall={onChangeItem}
                          defaultValue={userData.country}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              )}
              <Grid
                container
                direction="row"
                alignItems="center"
                style={{ marginBottom: 20 }}
              >
                <Grid item xs={4}>
                  <Typography variant="h2">Email*</Typography>
                </Grid>
                <Grid item xs={8}>
                  <CustomInput
                    id="email"
                    variant="outlined"
                    placeholder="Email"
                    parentcall={setInputState}
                    helperText={
                      submitClickFlag && userData.email === ""
                        ? "* Please enter email"
                        : submitClickFlag &&
                          emailInvalidFlag &&
                          userData.email !== ""
                        ? "Please enter valid email"
                        : ""
                    }
                    error={
                      (submitClickFlag && userData.email === "") ||
                      (submitClickFlag &&
                        emailInvalidFlag &&
                        userData.email !== "")
                        ? true
                        : false
                    }
                    value={userData.email}
                  />
                </Grid>
              </Grid>
              <Grid
                container
                direction="row"
                alignItems="center"
                style={{ marginBottom: 20 }}
              >
                <Grid item xs={4}>
                  <Typography variant="h2">Secondary email</Typography>
                </Grid>
                <Grid item xs={8}>
                  <CustomInput
                    id="secondary_email"
                    variant="outlined"
                    placeholder="Secondary email"
                    parentcall={setInputState}
                    value={userData.secondary_email}
                  />
                </Grid>
              </Grid>

              <Grid
                container
                direction="row"
                alignItems="center"
                style={{ marginBottom: 20 }}
              >
                <Grid item xs={4}>
                  <Typography variant="h2">Mobile*</Typography>
                </Grid>
                <Grid item xs={8}>
                  <PhoneInput
                    country={"gb"}
                    value={"" + userData.phone}
                    onChange={(value) => {
                      setUserData({ ...userData, ["phone"]: value });
                    }}
                    defaultErrorMessage="*  Please enter mobile number"
                  />
                  {(userData.phone === "" ||
                    userData.phone.toString().length < 4) &&
                    submitClickFlag && (
                      <Typography
                        variant="h2"
                        style={{
                          color: "#f44336",
                          marginTop: 3,
                          marginLeft: 0,
                        }}
                      >
                        * Please enter mobile number
                      </Typography>
                    )}
                </Grid>
              </Grid>
              <Grid
                container
                direction="row"
                alignItems="center"
                style={{ marginBottom: 20 }}
              >
                <Grid item xs={4}>
                  <Typography variant="h2">Telephone *</Typography>
                </Grid>
                <Grid item xs={8}>
                  <PhoneInput
                    country={"gb"}
                    value={"" + userData.telephone}
                    onChange={(value) => {
                      setUserData({ ...userData, ["telephone"]: value });
                    }}
                    defaultErrorMessage="*  Please enter telephone"
                  />
                  {(userData.telephone === "" ||
                    userData.telephone.length < 4) &&
                    submitClickFlag && (
                      <Typography
                        variant="h2"
                        style={{
                          color: "#f44336",
                          marginTop: 3,
                          marginLeft: 0,
                        }}
                      >
                        * Please enter telephone
                      </Typography>
                    )}
                </Grid>
              </Grid>

              <Grid
                container
                direction="row"
                alignItems="center"
                style={{ marginBottom: 20 }}
              >
                <Grid item xs={4}>
                  <Typography variant="h2">PA name</Typography>
                </Grid>
                <Grid item xs={8}>
                  <CustomInput
                    id="pa_name"
                    variant="outlined"
                    placeholder="PA name"
                    parentcall={setInputState}
                    value={userData.pa_name}
                  />
                </Grid>
              </Grid>
              <Grid
                container
                direction="row"
                alignItems="center"
                style={{ marginBottom: 20 }}
              >
                <Grid item xs={4}>
                  <Typography variant="h2">PA contact details</Typography>
                </Grid>
                <Grid item xs={8}>
                  <CustomInput
                    id="pa_contact_details"
                    variant="outlined"
                    placeholder="PA contact details"
                    parentcall={setInputState}
                    value={userData.pa_contact_details}
                  />
                </Grid>
              </Grid>

              <Grid container direction="row" style={{ marginBottom: 20 }}>
                <Grid item xs={4}>
                  <Typography variant="h2" style={{ paddingTop: "8px" }}>
                    Office address{role !== "admin" ? "*" : ""}
                  </Typography>
                </Grid>

                <Grid item xs={8}>
                  <Grid
                    container
                    direction="row"
                    alignItems="center"
                    spacing={1}
                  >
                    <Grid container direction="row" alignItems="center">
                      <Grid item xs={12}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              onChange={(e: any) =>
                                toggleAddress(e.target.checked)
                              }
                              checked={copyFlag}
                              name="acceptance"
                              color="primary"
                            />
                          }
                          label={
                            <Typography variant="h2">
                              Use same address as above
                            </Typography>
                          }
                        />
                      </Grid>
                    </Grid>
                    <Grid item xs={12} style={{ marginBottom: 10 }}>
                      <CustomInput
                        id="office_address"
                        variant="outlined"
                        placeholder="Office address"
                        parentcall={setInputState}
                        helperText={
                          role !== "admin" &&
                          submitClickFlag &&
                          userData.office_address === ""
                            ? "Please enter office address"
                            : ""
                        }
                        error={
                          role !== "admin" &&
                          submitClickFlag &&
                          userData.office_address === ""
                            ? true
                            : false
                        }
                        value={userData.office_address}
                      />
                    </Grid>
                    <Grid item xs={12} style={{ marginBottom: 10 }}>
                      <CustomInput
                        id="business_address_line1"
                        variant="outlined"
                        placeholder="Office address 1"
                        parentcall={setInputState}
                        // helperText={
                        //   role != "admin" &&
                        //   submitClickFlag &&
                        //   userData.business_address_line1 == ""
                        //     ? "Please enter office address 1"
                        //     : ""
                        // }
                        // error={
                        //   role != "admin" &&
                        //   submitClickFlag &&
                        //   userData.business_address_line1 == ""
                        //     ? true
                        //     : false
                        // }
                        value={userData.business_address_line1}
                      />
                    </Grid>
                    <Grid item xs={12} style={{ marginBottom: 10 }}>
                      <CustomInput
                        id="business_address_line2"
                        variant="outlined"
                        placeholder="Office address 2"
                        parentcall={setInputState}
                        // helperText={
                        //   role != "admin" &&
                        //   submitClickFlag &&
                        //   userData.business_address_line2 == ""
                        //     ? "Please enter office address 2"
                        //     : ""
                        // }
                        // error={
                        //   role != "admin" &&
                        //   submitClickFlag &&
                        //   userData.business_address_line2 == ""
                        //     ? true
                        //     : false
                        // }
                        value={userData.business_address_line2}
                      />
                    </Grid>
                    <Grid item xs={12} style={{ marginBottom: 10 }}>
                      <CustomInput
                        id="business_city"
                        variant="outlined"
                        placeholder="Office city/town"
                        parentcall={setInputState}
                        value={userData.business_city}
                        helperText={
                          role !== "admin" &&
                          submitClickFlag &&
                          userData.business_city === ""
                            ? "Please enter office city/town"
                            : ""
                        }
                        error={
                          role !== "admin" &&
                          submitClickFlag &&
                          userData.business_city === ""
                            ? true
                            : false
                        }
                      />
                    </Grid>
                    <Grid item xs={12} style={{ marginBottom: 10 }}>
                      <CustomInput
                        id="business_county"
                        variant="outlined"
                        placeholder="Office county/state/region"
                        parentcall={setInputState}
                        value={userData.business_county}
                        helperText={
                          role !== "admin" &&
                          submitClickFlag &&
                          (userData.business_county === "" ||
                            userData.business_county === undefined)
                            ? "Please select office county/state/region"
                            : ""
                        }
                        error={
                          role !== "admin" &&
                          submitClickFlag &&
                          userData.business_county === ""
                            ? true
                            : false
                        }
                        defaultValue={userData.business_county}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Grid
                        container
                        direction="row"
                        alignItems="center"
                        spacing={2}
                      >
                        <Grid item xs={6}>
                          <CustomInput
                            id="business_postcode"
                            variant="outlined"
                            placeholder="Office post/zip code"
                            helperText={
                              role !== "admin" &&
                              submitClickFlag &&
                              userData.business_postcode === ""
                                ? "Please enter office post/zip code"
                                : ""
                            }
                            error={
                              role !== "admin" &&
                              submitClickFlag &&
                              userData.business_postcode === ""
                                ? true
                                : false
                            }
                            parentcall={setInputState}
                            value={userData.business_postcode}
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <CustomSelect
                            id="business_country_list_id"
                            labelText="Select office country"
                            displayEmpty
                            variant="outlined"
                            itemArr={businessCountryListsArr}
                            parentcall={onChangeItem}
                            helperText={
                              role !== "admin" &&
                              submitClickFlag &&
                              (userData.business_country_list_id === "" ||
                                userData.business_country_list_id === undefined)
                                ? "Please select office country"
                                : ""
                            }
                            error={
                              role !== "admin" &&
                              submitClickFlag &&
                              userData.business_country_list_id === ""
                                ? true
                                : false
                            }
                            defaultValue={userData.business_country_list_id}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                container
                direction="row"
                alignItems="center"
                style={{ marginBottom: 20 }}
              >
                <Grid item xs={4}>
                  <Typography variant="h2">
                    Office phone{role !== "admin" ? "*" : ""}
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <PhoneInput
                    country={"gb"}
                    value={"" + userData.business_phone}
                    onChange={(value) => {
                      setUserData({ ...userData, ["business_phone"]: value });
                    }}
                    defaultErrorMessage="*  Please enter office phone"
                  />
                  {role !== "admin" &&
                    (userData.business_phone === "" ||
                      userData.business_phone.length < 4) &&
                    submitClickFlag && (
                      <Typography
                        variant="h2"
                        style={{
                          color: "#f44336",
                          marginTop: 3,
                          marginLeft: 0,
                        }}
                      >
                        * Please enter office phone
                      </Typography>
                    )}
                </Grid>
              </Grid>
              <Grid
                container
                direction="row"
                alignItems="center"
                style={{ marginBottom: 20 }}
              >
                <Grid item xs={4}>
                  <Typography variant="h2">
                    Office mobile{role !== "admin" ? "*" : ""}
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <PhoneInput
                    country={"gb"}
                    value={"" + userData.business_mobile_number}
                    onChange={(value) => {
                      setUserData({
                        ...userData,
                        ["business_mobile_number"]: value,
                      });
                    }}
                    defaultErrorMessage="*  Please enter office mobile"
                  />
                  {role !== "admin" &&
                    (userData.business_mobile_number === "" ||
                      userData.business_mobile_number.length < 4) &&
                    submitClickFlag && (
                      <Typography
                        variant="h2"
                        style={{
                          color: "#f44336",
                          marginTop: 3,
                          marginLeft: 0,
                        }}
                      >
                        * Please enter office mobile
                      </Typography>
                    )}
                </Grid>
              </Grid>
              {role === "admin" && (
                <Grid
                  container
                  direction="row"
                  alignItems="center"
                  style={{ marginTop: 45, marginBottom: 20 }}
                >
                  <Grid item xs={4}>
                    <Typography variant="h2">Location radius (km)</Typography>
                  </Grid>
                  <Grid item xs={8}>
                    <Slider
                      value={userData.location_radius}
                      onChange={handleChange}
                      aria-labelledby="continuous-slider"
                      step={10}
                      valueLabelDisplay="on"
                    />
                  </Grid>
                </Grid>
              )}
              <Grid
                container
                direction="row"
                alignItems="center"
                style={{ marginBottom: 20 }}
              >
                <Grid item xs={4}>
                  <Typography variant="h2">Linkedin</Typography>
                </Grid>
                <Grid item xs={8}>
                  <CustomInput
                    id="linkedin"
                    variant="outlined"
                    placeholder="Linkedin"
                    parentcall={setInputState}
                    value={userData.linkedin}
                  />
                </Grid>
              </Grid>
              <Grid
                container
                direction="row"
                alignItems="center"
                style={{ marginBottom: 20 }}
              >
                <Grid item xs={4}>
                  <Typography variant="h2">Skype</Typography>
                </Grid>
                <Grid item xs={8}>
                  <CustomInput
                    id="skype"
                    variant="outlined"
                    placeholder="Skype"
                    parentcall={setInputState}
                    value={userData.skype}
                  />
                </Grid>
              </Grid>
              <Grid
                container
                direction="row"
                alignItems="center"
                style={{ marginBottom: 20 }}
              >
                <Grid item xs={4}>
                  <Typography variant="h2">Twitter</Typography>
                </Grid>
                <Grid item xs={8}>
                  <CustomInput
                    id="twitter"
                    variant="outlined"
                    placeholder="Twitter"
                    parentcall={setInputState}
                    value={userData.twitter}
                  />
                </Grid>
              </Grid>

              <Grid
                container
                direction="row"
                alignItems="center"
                style={{ marginBottom: 20 }}
              >
                <Grid item xs={4}>
                  <Typography variant="h2">Facebook</Typography>
                </Grid>
                <Grid item xs={8}>
                  <CustomInput
                    id="facebook"
                    variant="outlined"
                    placeholder="Facebook"
                    parentcall={setInputState}
                    value={userData.facebook}
                  />
                </Grid>
              </Grid>
              <Grid
                container
                direction="row"
                alignItems="center"
                style={{ marginBottom: 20 }}
              >
                <Grid item xs={4}>
                  <Typography variant="h2">Website 1</Typography>
                </Grid>
                <Grid item xs={8}>
                  <CustomInput
                    id="website"
                    variant="outlined"
                    placeholder="Website1"
                    parentcall={setInputState}
                    value={userData.website}
                  />
                </Grid>
              </Grid>
              <Grid
                container
                direction="row"
                alignItems="center"
                style={{ marginBottom: 20 }}
              >
                <Grid item xs={4}>
                  <Typography variant="h2">Website 2</Typography>
                </Grid>
                <Grid item xs={8}>
                  <CustomInput
                    id="website2"
                    variant="outlined"
                    placeholder="Website 2"
                    parentcall={setInputState}
                    value={userData.website2}
                  />
                </Grid>
              </Grid>
              <Grid
                container
                direction="row"
                alignItems="center"
                style={{ marginBottom: 20 }}
              >
                <Grid item xs={4}>
                  <Typography variant="h2">
                    Currently available for assignment
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <CustomSelect
                    labelText="Select currently available for assignment"
                    id="currently_available_for_assignment"
                    displayEmpty
                    variant="outlined"
                    itemArr={["Yes", "No"]}
                    parentcall={onChangeItem}
                    defaultValue={
                      userData.currently_available_for_assignment !== ""
                        ? userData.currently_available_for_assignment === "true"
                          ? "Yes"
                          : "No"
                        : "0"
                    }
                  />
                </Grid>
              </Grid>
              <Grid container direction="row" alignItems="center">
                <Grid item xs={4}>
                  <Typography variant="h2">Next available date</Typography>
                </Grid>
                <Grid item xs={8}>
                  {userData.currently_available_for_assignment !== "" &&
                  userData.currently_available_for_assignment === "true" ? (
                    <Typography variant="h2" style={{ marginBottom: "16px" }}>
                      Available Now
                    </Typography>
                  ) : (
                    <DateComponent
                      key={"001"}
                      componentObject={{
                        componentType: "datePicker",
                        required: true,
                        label: "",
                        name: "next_available_date",
                        placeholder: "Next available date",
                        helperText: false,
                        indexKey: "0-0",
                        index: "next_available_date",
                        handleChange: setInputState,
                        value: userData.next_available_date,
                      }}
                    />
                  )}
                </Grid>
              </Grid>
              {role === "admin" && (
                <Grid
                  container
                  direction="row"
                  alignItems="center"
                  style={{ marginBottom: 20 }}
                >
                  <Grid item xs={4}>
                    <Typography variant="h2">
                      General internal comments
                    </Typography>
                  </Grid>
                  <Grid item xs={8}>
                    <CustomInput
                      id="general_internal_comment"
                      multiline={true}
                      rows={4}
                      variant="outlined"
                      placeholder="General internal comments"
                      parentcall={setInputState}
                      value={userData.general_internal_comment}
                    />
                  </Grid>
                </Grid>
              )}
              {role === "admin" && (
                <Grid
                  container
                  direction="row"
                  alignItems="center"
                  style={{ marginBottom: 30 }}
                >
                  <Grid item xs={4}>
                    <Typography variant="h2">Onboarded</Typography>
                  </Grid>
                  <Grid item xs={8} style={{ marginBottom: "30px" }}>
                    <CustomRadioButton
                      id="associate_coach"
                      itemArr={["Yes", "No"]}
                      parentcall={setInputState}
                      index={userData.associate_coach ? 0 : 1}
                    />
                  </Grid>
                </Grid>
              )}
            </Grid>
          </Grid>
          <Header saveBtnTitle={"Save and proceed"} parentcall={onSubmit} />
          {showAddNewModalExist && showAddNewModal && (
            <AddToListModal
              type="partner_profiles"
              postData={{ ...addNewModalProps }}
            />
          )}
          {loading && <CircularIndeterminate />}
        </>
      }
    </div>
  );
}

export default BasicInfo;
